import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showTimeMenu, showTeamMenu, editBooking, setBookingFieldThunk } from '../../store/ResourceStore';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import Unit from './Unit';

const TimeSelectForm = () => {
    const dispatch = useDispatch();

    const resState = useSelector((state) => state.resourceState);

    const showMenu = resState.showTimeMenu;
    if(!showMenu) return null;

    const unitBookingId = resState.bookingIdToEdit;
    //Det er bevidst at der er tastet != og ikke !==
    const isEditMode = unitBookingId != null;
    const bookings = resState.bookings;
    const booking = bookings.find(x => x.id === unitBookingId);

    const units = resState.units;
    const unitBooking = isEditMode ? booking.unit : units.find(x => x.id === resState.createBooking.unitId);
    const model = isEditMode ? booking : resState.createBooking;

    return(
        <div className='dialog-overlay' onClick={() => dispatch(showTimeMenu(false))}>
            <div className='dialog timechooser' onClick={(e) => e.stopPropagation()}>
                <div className='unit-container'>
                    <Unit unit={unitBooking} hideText noMenu hideName/>
                    <div className='clearfix'/>
                </div>
                <h1>Hvornår skal "{unitBooking.name}" reserveres?</h1>
                <div className='container'>
                    <div className="form-group date">
                        <label>Start</label>
                        <Flatpickr
                            options={{time_24hr: true, enableTime: true, minuteIncrement: 30}}
                            onChange={(d) => dispatch(setBookingFieldThunk('startTime', d[0], model))}                            
                            value={moment(model.startTime).format('YYYY-MM-DD HH:mm')}
                            className={'date-picker-custom'}
                        />
                    </div>
                    <div className="form-group date">
                        <label>Slut</label>
                        <Flatpickr
                            options={{time_24hr: true, enableTime: true, minuteIncrement: 30}}
                            onChange={d => dispatch(setBookingFieldThunk('endTime', d[0], model))} 
                            value={moment(model.endTime).format('YYYY-MM-DD HH:mm')}
                            className={'date-picker-custom'}
                        />
                    </div>
                </div>
                <div className='clearfix'/>
                {resState.doubleBook &&
                    <div className='error'>Denne tidsperiode, eller dele af denne tidsperiode er desværre allerede booket.</div>
                }
                <div 
                    className='dialog-btn' 
                    onClick={() => {
                        dispatch(showTimeMenu(false)); 
                        isEditMode ? dispatch(editBooking({id: model.id, startTime: resState.createBooking.startTime, endTime: resState.createBooking.endTime})) : dispatch(showTeamMenu(true));}}>Videre</div>
            </div>
        </div>
    )
};

export default TimeSelectForm;